import Vue from "vue";
import base from "./baseCore";

const buildQueryParams = ({
    search,
    active,
    orderBy,
    desc,
    date,
    local,
    establishments,
    advertising
}) => {
    return {
        filtro: search,
        filtroAtivo: active,
        ordem: orderBy,
        desc: desc,
        locais: local,
        "data.min": date.min,
        "data.max": date.max,
        estabelecimentos: establishments,
        campaigns: advertising
    };
};

export default Object.assign(
    {
        apiUrl: "/acesso/comentario",

        async list({ page, filters }) {
            const url = this.userUrl({
                path: `/${page}/30`
            });
            const query = buildQueryParams(filters);

            return await Vue.http.get(url, {
                params: query
            });
        },

        async fetchCsv({ filters }) {
            return Vue.http({
                url: this.userUrl({ path: `/csv` }),
                method: "GET",
                responseType: "blob", // important
                params: buildQueryParams(filters)
            });
        }
    },
    base
);
